export default "__VITE_ASSET__CinE4xnF__"